module.exports = __webpack_public_path__ + "static/media/odg-formato-de-archivo-abierto.5c487526.svg";